<template>
  <div>
    <div class="columns">
      <div class="column is-2">
        <h1 class="title is-4">Empleados</h1>
      </div>
      <div class="column">
        <div class="buttons">
          <button class="button is-link" @click="showFormEmployee()">
            Crear
          </button>
          <button class="button is-link">Cargar desde Excel</button>
        </div>
      </div>
    </div>
    <div class="notification" v-show="formEmployee">
      <div class="columns is-multiline">
        <div class="column is-4">
          <div class="field">
            <label class="label">Identificación</label>
            <div class="control">
              <input
                @blur="blurcodigo()"
                v-model="employee.codigo"
                class="input"
                type="text"
                placeholder="Identificación"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Tipo de Documento</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="employee.employee.tipoDocumento">
                  <option :value="null">Seleccionar</option>
                  <option :value="'11'">Registro civil</option>
                  <option :value="'12'">Tarjeta de identidad</option>
                  <option :value="'13'">Cedula de ciudadanía</option>
                  <option :value="'21'">Tarjeta de extranjería</option>
                  <option :value="'22'">Cedula de extranjería</option>
                  <option :value="'31'">Nit</option>
                  <option :value="'41'">Pasaporte</option>
                  <option :value="'42'">
                    Documento de idetficiación extranjero
                  </option>
                  <option :value="'47'">PEP</option>
                  <option :value="'50'">NIT de otro país</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Tipo de Trabajador</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="employee.employee.tipoTrabajador">
                  <option :value="null">Seleccionar</option>
                  <option :value="'01'">Dependiente</option>
                  <option :value="'02'">Servicio domestico</option>
                  <option :value="'04'">Madre comunitaria</option>
                  <option :value="'12'">
                    Aprendices del Sena en etapa lectiva
                  </option>
                  <option :value="'18'">
                    Funcionarios públicos sin tope máximo de ibc
                  </option>
                  <option :value="'19'">
                    Aprendices del SENA en etapa productiva
                  </option>
                  <option :value="'21'">
                    Estudiantes de postgrado en salud
                  </option>
                  <option :value="'22'">
                    Profesor de establecimiento particular
                  </option>
                  <option :value="'23'">
                    Estudiantes aportes solo riesgos laborales
                  </option>
                  <option :value="'30'">
                    Dependiente entidades o universidades públicas con régimen
                    especial en salud
                  </option>
                  <option :value="'31'">
                    Cooperados o pre cooperativs de trabajo asociado
                  </option>
                  <option :value="'47'">
                    Trabajador dependiente de entidad beneficiaria del sistema
                    general de participaciones - aportes patronales
                  </option>
                  <option :value="'51'">Trabajador de tiempo parcial</option>
                  <option :value="'54'">
                    Pre pensionado de entidad en liquidación
                  </option>
                  <option :value="'56'">
                    Pre pensionado con aporte voluntario a salud
                  </option>
                  <option :value="'58'">
                    Estudiantes de prácticas laborales en el sector público
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="field">
            <label class="label">Primer Nombre</label>
            <div class="control">
              <input
                v-model="employee.nombre1"
                class="input"
                type="text"
                placeholder="Nombre"
              />
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="field">
            <label class="label">Segundo Nombre</label>
            <div class="control">
              <input
                v-model="employee.nombre2"
                class="input"
                type="text"
                placeholder="Segundo Nombre"
              />
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="field">
            <label class="label">Primer Apellido</label>
            <div class="control">
              <input
                v-model="employee.apellido1"
                class="input"
                type="text"
                placeholder="Apellido"
              />
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="field">
            <label class="label">Segundo Apellido</label>
            <div class="control">
              <input
                v-model="employee.apellido2"
                class="input"
                type="text"
                placeholder="Segundo Apellido"
              />
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field">
            <label class="label">Tipo de Contrato</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="employee.employee.tipoContrato">
                  <option :value="null">Seleccionar</option>
                  <option :value="'1'">Término Fijo</option>
                  <option :value="'2'">Término Indefinido</option>
                  <option :value="'3'">Obra o Labor</option>
                  <option :value="'4'">Aprendizaje</option>
                  <option :value="'5'">Prácticas o Pasantías</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Periodo Nómina</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="employee.employee.periodoNomina">
                  <option :value="null">Seleccionar</option>
                  <option :value="'1'">Semanal</option>
                  <option :value="'2'">Decenal</option>
                  <option :value="'3'">Catorcenal</option>
                  <option :value="'4'">Quincenal</option>
                  <option :value="'5'">Mensual</option>
                  <option :value="'6'">Otro</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Alto riesgo pensional</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="employee.employee.altoRiesgoPension">
                  <option :value="false">No</option>
                  <option :value="true">Si</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Salario Integral</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="employee.employee.salarioIntegral">
                  <option :value="false">No</option>
                  <option :value="true">Si</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Fecha Ingreso</label>
            <div class="control">
              <div class="select is-fullwidth">
                <input
                  v-model="employee.employee.fechaIngreso"
                  class="input"
                  type="date"
                  placeholder="Identificación"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Medio de pago</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="employee.employee.metodoPago">
                  <option :value="null">Seleccionar</option>
                  <option :value="'1'">Instrumento no definido</option>
                  <option :value="'2'">Crédito ACH</option>
                  <option :value="'3'">Débito ACH</option>
                  <option :value="'4'">Reversión débito de demanda ACH</option>
                  <option :value="'5'">Reversión crédito de demanda ACH</option>
                  <option :value="'6'">Crédito de demanda ACH</option>
                  <option :value="'7'">Débito de demanda ACH</option>
                  <option :value="'8'">Mantener</option>
                  <option :value="'9'">Clearing Nacional o Regional</option>
                  <option :value="'10'">Efectivo</option>
                  <option :value="'11'">Reversión Crédito Agorro</option>
                  <option :value="'12'">Reversión Débito Agorro</option>
                  <option :value="'13'">Crédito Ahorro</option>
                  <option :value="'14'">Débito Ahorro</option>
                  <option :value="'15'">Bookentry Crédito</option>
                  <option :value="'16'">Bookentry Débito</option>
                  <option :value="'17'">
                    Concentración de la demanda en efectivo /Desembolso Crédito
                    (CCD)
                  </option>
                  <option :value="'18'">
                    Concentración de la demanda en efectivo / Desembolso (CCD)
                    débito
                  </option>
                  <option :value="'19'">
                    Crédito Pago negocio corporativo (CTP)
                  </option>
                  <option :value="'20'">Cheque</option>
                  <option :value="'21'">Proyecto bancario</option>
                  <option :value="'22'">Proyecto bancario certificado</option>
                  <option :value="'23'">Cheque bancario</option>
                  <option :value="'24'">
                    Nota cambiaria esperando aceptación
                  </option>
                  <option :value="'25'">Cheque certificado</option>
                  <option :value="'26'">Cheque Local</option>
                  <option :value="'27'">
                    Débito Pago Negocio Corporativo (CTP)
                  </option>
                  <option :value="'28'">
                    Crédito Negocio Intercambio Corporativo (CTX)
                  </option>
                  <option :value="'29'">
                    Débito Negocio Intercambio Corporativo (CTX)
                  </option>
                  <option :value="'30'">Transferencia Crédito</option>
                  <option :value="'31'">Transferencia Débito</option>
                  <option :value="'32'">
                    Concentración Efectivo / Desembolso Crédito plus (CCD+)
                  </option>
                  <option :value="'33'">
                    Concentración Efectivo / Desembolso Débito plus (CCD+)
                  </option>
                  <option :value="'34'">
                    Pago y depósito pre acordado (PPD)
                  </option>
                  <option :value="'35'">
                    Concentración efectivo ahorros / Desembolso Crédito (CCD)
                  </option>
                  <option :value="'36'">
                    Concentración efectivo ahorros / Desembolso Crédito (CCD)
                  </option>
                  <option :value="'37'">
                    Pago Negocio Corporativo Ahorros Crédito (CTP)
                  </option>
                  <option :value="'38'">
                    Pago Negocio Corporativo Ahorros Débito (CTP)
                  </option>
                  <option :value="'39'">
                    Crédito Negocio Intercambio Corporativo (CTX)
                  </option>
                  <option :value="'40'">
                    Débito Negocio Intercambio Corporativo (CTX)
                  </option>
                  <option :value="'41'">
                    Concentración efectivo/Desembolso Crédito plus (CCD+)
                  </option>
                  <option :value="'42'">Consignación bancaria</option>
                  <option :value="'43'">
                    Concentración efectivo / Desembolso Débito plus (CCD+)
                  </option>
                  <option :value="'44'">Nota cambiaria</option>
                  <option :value="'45'">Transferencia Crédito Bancario</option>
                  <option :value="'46'">
                    Transferencia Débito Interbancario
                  </option>
                  <option :value="'47'">Transferencia Débito Bancaria</option>
                  <option :value="'48'">Tarjeta Crédito</option>
                  <option :value="'49'">Tarjeta Débito</option>
                  <option :value="'50'">Postgiro</option>
                  <option :value="'51'">Telex estándar bancario francés</option>
                  <option :value="'52'">Pago comercial urgente</option>
                  <option :value="'53'">Pago Tesorería Urgente</option>
                  <option :value="'60'">Nota promisoria</option>
                  <option :value="'61'">
                    Nota promisoria firmada por el acreedor
                  </option>
                  <option :value="'62'">
                    Nota promisoria firmada por el acreedor, avalada por el
                    banco
                  </option>
                  <option :value="'63'">
                    Nota promisoria firmada por el acreedor, avalada por un
                    tercero
                  </option>
                  <option :value="'64'">
                    Nota promisoria firmada por el banco
                  </option>
                  <option :value="'65'">
                    Nota promisoria firmada por un banco avalada por otro banco
                  </option>
                  <option :value="'66'">Nota promisoria firmada</option>
                  <option :value="'67'">
                    Nota promisoria firmada por un tercero avalada por un banco
                  </option>
                  <option :value="'70'">
                    Retiro de nota por el por el acreedor
                  </option>
                  <option :value="'71'">Bonos</option>
                  <option :value="'72'">Vales</option>
                  <option :value="'74'">
                    Retiro de nota por el por el acreedor sobre un banco
                  </option>
                  <option :value="'75'">
                    Retiro de nota por el acreedor, avalada por otro banco
                  </option>
                  <option :value="'76'">
                    Retiro de nota por el acreedor, sobre un banco avalada por
                    un tercero
                  </option>
                  <option :value="'77'">
                    Retiro de una nota por el acreedor sobre un tercero
                  </option>
                  <option :value="'78'">
                    Retiro de una nota por el acreedor sobre un tercero avalada
                    por un banco
                  </option>
                  <option :value="'91'">Nota bancaria transferible</option>
                  <option :value="'92'">Cheque local trasferible</option>
                  <option :value="'93'">Giro referenciado</option>
                  <option :value="'94'">Giro urgente</option>
                  <option :value="'95'">Giro formato abierto</option>
                  <option :value="'96'">
                    Método de pago solicitado no usado
                  </option>
                  <option :value="'97'">Clearing entre partners</option>
                  <option :value="'98'">
                    Cuentas de Ahorro de Tramite Simplificado (CATS)(Nequi,
                    Daviplata, etc)
                  </option>
                  <option :value="'ZZZ'">Acuerdo mutuo</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Banco</label>
            <div class="control">
              <input
                v-model="employee.employee.banco"
                class="input"
                type="text"
                placeholder="Nombre del Banco"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Tipo de cuenta</label>
            <div class="control">
              <input
                v-model="employee.employee.tipoCuenta"
                class="input"
                type="text"
                placeholder="Tipo de Cuenta"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Número de Cuenta</label>
            <div class="control">
              <input
                v-model="employee.employee.numeroCuenta"
                class="input"
                type="text"
                placeholder="Tipo de Cuenta"
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Salario</label>
            <div class="control">
              <input
                v-model="employee.employee.sueldo"
                class="input"
                type="number"
                placeholder="Salario base"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="buttons">
            <button class="button is-link is-large" @click="save">
              Guardar
            </button>
            <button class="button is-large" @click="cancel">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container">
      <table class="table">
        <thead>
          <tr>
            <th>Cédula</th>
            <th>Nombre</th>
            <th>Salario</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in employees" :key="index">
            <td class="fontMono has-text-right">
              {{ item.codigo | textnumber() }}
            </td>
            <td>{{ item.nombre }}</td>
            <td class="has-text-right fontMono">
              {{ item.employee.sueldo | number() }}
            </td>
            <td>
              <button
                class="button is-small is-info"
                @click="editEmployee(item)"
              >
                <span class="icon is-small">
                  <span class="material-icons"> edit </span>
                </span>
              </button>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
export default {
  data() {
    return {
      formEmployee: false,
      employee: {
        _id: null,
        nombre1: null,
        nombre2: null,
        apellido1: null,
        apellido2: null,
        codigo: null,
        isemployee: true,
        tipo: "Persona Natural",
        direccion: null,
        ciudad: null,
        employee: {
          tipoDocumento: null,
          tipoTrabajador: null,
          tipoContrato: null,
          altoRiesgoPension: false,
          salarioIntegral: false,
          fechaIngreso: null,
          periodoNomina: null,
          formaPago: "1",
          metodoPago: "42",
          banco: null,
          tipoCuenta: "Ahorros",
          numeroCuenta: null,
          sueldo: 0,
        },
      },
      employees: [],
    };
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    editEmployee(e) {
      console.log("the employee is", e);
      this.employee = e;
      this.formEmployee = true;
    },
    cancel() {
      this.formEmployee = false;
      this.employee = {
        _id: null,
        nombre1: null,
        nombre2: null,
        apellido1: null,
        apellido2: null,
        codigo: null,
        isemployee: true,
        tipo: "Persona Natural",
        direccion: null,
        ciudad: null,
        employee: {
          tipoDocumento: null,
          tipoTrabajador: null,
          tipoContrato: null,
          altoRiesgoPension: false,
          salarioIntegral: false,
          fechaIngreso: null,
          periodoNomina: null,
          formaPago: "1",
          metodoPago: "42",
          banco: null,
          tipoCuenta: "Ahorros",
          numeroCuenta: null,
          sueldo: 0,
        },
      };
      this.employee.direccion = this.empresa.direccion;
      this.employee.ciudad = `${this.empresa.codciudad} - ${this.empresa.ciudad}`;
    },
    async save() {
      try {
        // aqui valido los campos
        if (!this.employee.codigo) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar la identificación del empleado.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.tipoDocumento) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar el tipo de documento.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.tipoTrabajador) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar el tipo de trabajador.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.nombre1) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar el primer nombre.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.apellido1) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar el primer apellido.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.tipoContrato) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar el tipo de contrato.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.periodoNomina) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar la periodicidad de la nómina.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.fechaIngreso) {
          this.$store.dispatch("notify", {
            message:
              "Debe ingresar la fecha en la que el empleado empezo a laborar en la empresa.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.metodoPago) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar un medio de pago.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.banco) {
          this.$store.dispatch("notify", {
            message:
              "Debe ingrear el nombre del banco en el cual le consigna la nomina al empleado.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.tipoCuenta) {
          this.$store.dispatch("notify", {
            message: "Debe indicar el tipo de cuenta bancaria del empleado.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.numeroCuenta) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar el número de cuenta del empleado.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.employee.employee.sueldo) {
          this.$store.dispatch("notify", {
            message: "Debe indicar el salario del empleado.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (this.employee._id) {
          // edita el nit
          await apiServices.post(`/editemployee`, this.employee);
        } else {
          // crea el nit
          await apiServices.post(`/createemployee`, this.employee);
        }
        this.cancel();
        this.findEmployees();
      } catch (err) {
        console.log(err);
      }
    },
    showFormEmployee() {
      if (this.formEmployee) {
        this.formEmployee = false;
      } else {
        this.formEmployee = true;
      }
    },
    blurcodigo() {
      console.log(this.employee.codigo);
      this.findTercero();
    },
    async findTercero() {
      try {
        const result = await apiServices.post(`/nitbycodigo`, {
          codigo: this.employee.codigo,
        });
        if (result.data) {
          console.log(result.data);
          this.employee._id = result.data._id;
          this.employee.nombre1 = result.data.nombre1;
          this.employee.nombre2 = result.data.nombre2;
          this.employee.apellido1 = result.data.apellido1;
          this.employee.apellido2 = result.data.apellido2;
          this.employee.direccion = result.data.direccion;
          this.employee.ciudad = result.data.ciudad;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findEmployees() {
      try {
        const result = await apiServices.get(`/findemployees`);
        if (result.data) {
          this.employees = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.employee.direccion = this.empresa.direccion;
    this.employee.ciudad = `${this.empresa.codciudad} - ${this.empresa.ciudad}`;
    this.findEmployees();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/nomina/empleados/Empleados.vue